import {
  GET_SCHEMAS,
  GETTING_SCHEMAS,
  GETTING_SCHEMAS_SUCCEEDED,
  GETTING_SCHEMAS_FAILED,
  GETTING_SCHEMA_KEYS,
  GETTING_SCHEMA_KEYS_SUCCEEDED,
  GETTING_SCHEMA_KEYS_FAILED,
  GETTING_SCHEMA,
  GETTING_SCHEMA_SUCCEEDED,
  GETTING_SCHEMA_FAILED,
  GETTING_EVENT_TYPES_SUCCEEDED,
  GETTING_EVENT_TYPES_FAILED,
  CREATE_SCHEMA,
  CREATING_SCHEMA,
  CREATING_SCHEMA_SUCCEEDED,
  CREATING_SCHEMA_FAILED,
  UPDATE_SCHEMA,
  UPDATING_SCHEMA_SUCCEEDED,
  UPDATING_SCHEMA_FAILED,
  SET_CURRENT_SCHEMA,
  UNSET_CURRENT_SCHEMA,
  SET_CURRENT_SCHEMA_DETAILS,
  UNSET_CURRENT_SCHEMA_DETAILS,
  ACTIVATE_OR_DEACTIVATE_SCHEMA,
  ACTIVATE_OR_DEACTIVATE_SCHEMA_SUCCEEDED,
  ACTIVATE_OR_DEACTIVATE_SCHEMA_FAILED,
  LOADING_CURRENT_SCHEMA,
  GET_EVENT_IDENTIFIER_VALUES,
  GETTING_EVENT_IDENTIFIER_VALUES_SUCCEEDED,
  GET_SCHEMA,
  GET_PAGINATED_SCHEMAS,
  GETTING_PAGINATED_SCHEMAS,
  GETTING_PAGINATED_SCHEMAS_SUCCEEDED,
  GETTING_PAGINATED_SCHEMAS_FAILED,
  UPDATE_SCHEMA_FILTERS,
  RESET_SCHEMA_FILTERS,
  GETTING_SCHEMA_OPTIONS_SUCCEEDED,
  GETTING_SCHEMA_OPTIONS_FAILED
} from './actions';
import { createReducer } from '@reduxjs/toolkit';
import { Base64 } from 'js-base64';
import { listManagementProduct, guestInsightProduct } from 'constants.js';

const initialState = {
  getting: false,
  gettingPaginated: true,
  list: [],
  current: {},
  keys: {},
  currentDetails: {
    isDefaultSchema: false,
    hasMovedToNextStep: false
  },
  isSchemaSaved: false,
  schemaSaveFailed: false,
  schemaSaveFailedMessage: '',
  activateOrDeactivateSucceeded: false,
  activateOrDeactivateFailed: false,
  activateOrDeactivateFailedMessage: '',
  error: {
    message: null,
    raw: null
  },
  listManagementSchema: {},
  guestInsightSchema: {},
  creatingPaginated: false,
  deletingPaginated: false,
  paginatedList: [],
  filters: {
    pageNo: 0,
    searchInput: '',
    sortBy: 'schemaName',
    sortOrder: 'ASC',
    rowsPerPage: 10,
    totalCount: 0,
    displayActive: true,
    filterProductNames: [],
    filterProductCategories: []
  },
  eventIdentifier: {
    isLoading: false,
    values: []
  },
  schemaOptions: {}
};

export default createReducer(initialState, {
  [GET_SCHEMAS]: (state) => {
    state.activateOrDeactivateSucceeded = false;
    state.activateOrDeactivateFailed = false;
    state.isSchemaSaved = false;
    state.schemaSaveFailed = false;
    state.activateOrDeactivateFailedMessage = '';
    state.error = {};
    return state;
  },
  [GET_PAGINATED_SCHEMAS]: (state) => {
    state.error = {};
    return state;
  },
  [GETTING_SCHEMAS]: (state) => {
    state.getting = true;
    return state;
  },
  [GETTING_PAGINATED_SCHEMAS]: (state) => {
    state.gettingPaginated = true;
  },
  [GETTING_SCHEMAS_SUCCEEDED]: (state, action) => {
    state.getting = false;
    state.list = action.payload;
    state.listManagementSchema = {
      ...(action.payload.filter(
        (schemaObj) =>
          schemaObj.schemaName === listManagementProduct.SCHEMA_NAME
      )[0] || {})
    };
    state.guestInsightSchema = {
      ...(action.payload.filter(
        (schemaObj) => schemaObj.schemaName === guestInsightProduct.SCHEMA_NAME
      )[0] || {})
    };
    return state;
  },
  [GETTING_SCHEMAS_FAILED]: (state, action) => {
    state.getting = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [GET_SCHEMA]: (state) => {
    state.isSchemaSaved = false;
    state.schemaSaveFailed = false;
    state.error = {};
    return state;
  },
  [GETTING_SCHEMA]: (state) => {
    state.getting = true;
    return state;
  },
  [GETTING_SCHEMA_SUCCEEDED]: (state, action) => {
    state.getting = false;
    state.current = {
      ...action.payload,
      examplePayload:
        action.payload.examplePayload && action.payload.examplePayload !== ''
          ? Base64.decode(action.payload.examplePayload)
          : action.payload.examplePayload,
      schemaEnrichmentData: action.payload.schemaEnrichmentData || []
    };
    return state;
  },
  [GETTING_PAGINATED_SCHEMAS_SUCCEEDED]: (state, action) => {
    state.gettingPaginated = false;
    state.paginatedList = action.payload;
    state.listManagementSchema = {
      ...(action.payload.filter(
        (schemaObj) =>
          schemaObj.schemaName === listManagementProduct.SCHEMA_NAME
      )[0] || {})
    };
    state.guestInsightSchema = {
      ...(action.payload.filter(
        (schemaObj) => schemaObj.schemaName === guestInsightProduct.SCHEMA_NAME
      )[0] || {})
    };
    return state;
  },
  [GETTING_SCHEMA_FAILED]: (state, action) => {
    state.getting = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [GETTING_PAGINATED_SCHEMAS_FAILED]: (state, action) => {
    state.gettingPaginated = false;
    state.creatingPaginated = false;
    state.deletingPaginated = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [GETTING_SCHEMA_KEYS]: (state) => {
    state.getting = true;
    return state;
  },
  [GETTING_SCHEMA_KEYS_SUCCEEDED]: (state, action) => {
    state.keys = action.payload.properties;
    state.getting = false;
    return state;
  },
  [GETTING_SCHEMA_KEYS_FAILED]: (state, action) => {
    state.getting = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [CREATE_SCHEMA]: (state, action) => {
    state.current = {
      ...action.payload.schema,
      examplePayload:
        action.payload.schema.examplePayload !== ''
          ? Base64.encode(action.payload.schema.examplePayload)
          : action.payload.schema.examplePayload
    };
    return state;
  },
  [CREATING_SCHEMA]: (state) => {
    state.isSchemaSaved = false;
    state.schemaSaveFailed = false;
    return state;
  },
  [CREATING_SCHEMA_SUCCEEDED]: (state, action) => {
    state.current = {
      ...action.payload,
      schemaEnrichmentData: action.payload.schemaEnrichmentData || []
    };
    state.isSchemaSaved = true;
    return state;
  },
  [CREATING_SCHEMA_FAILED]: (state, action) => {
    state.schemaSaveFailed = true;
    state.schemaSaveFailedMessage = action.payload.isValidationFailed
      ? 'Please correct the above issues to save this schema.'
      : 'Unable to save the schema. Please check and try again.';
    state.isSchemaSaved = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    if (!action.payload.isValidationFailed) {
      state.current = {
        ...state.current,
        examplePayload:
          state.current.examplePayload !== ''
            ? Base64.decode(state.current.examplePayload)
            : state.current.examplePayload,
        schemaEnrichmentData: state.current.schemaEnrichmentData || []
      };
    }
    return state;
  },
  [UPDATE_SCHEMA]: (state, action) => {
    state.current = {
      ...action.payload.schema,
      examplePayload:
        action.payload.schema.examplePayload !== ''
          ? Base64.encode(action.payload.schema.examplePayload)
          : action.payload.schema.examplePayload
    };
    return state;
  },
  [UPDATING_SCHEMA_SUCCEEDED]: (state, action) => {
    state.current = {
      ...action.payload,
      schemaEnrichmentData: action.payload.schemaEnrichmentData || []
    };
    state.isSchemaSaved = true;
    return state;
  },
  [UPDATING_SCHEMA_FAILED]: (state, action) => {
    state.schemaSaveFailed = true;
    state.schemaSaveFailedMessage = action.payload.isValidationFailed
      ? 'Please correct the above issues to save this schema.'
      : 'Unable to save the schema. Please check and try again.';
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    if (!action.payload.isValidationFailed) {
      state.current = {
        ...state.current,
        examplePayload:
          state.current.examplePayload !== ''
            ? Base64.decode(state.current.examplePayload)
            : state.current.examplePayload,
        schemaEnrichmentData: state.current.schemaEnrichmentData || []
      };
    }
    return state;
  },
  [GETTING_EVENT_TYPES_SUCCEEDED]: (state, action) => {
    state.eventTypes = action.payload;
    return state;
  },
  [GETTING_EVENT_TYPES_FAILED]: (state, action) => {
    state.eventTypes = [];
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [SET_CURRENT_SCHEMA]: (state, action) => {
    state.current = {
      ...action.payload
    };
    return state;
  },
  [UNSET_CURRENT_SCHEMA]: (state) => {
    state.current = { ...initialState.current };
    return state;
  },
  [SET_CURRENT_SCHEMA_DETAILS]: (state, action) => {
    state.currentDetails = {
      ...action.payload
    };
    return state;
  },
  [UNSET_CURRENT_SCHEMA_DETAILS]: (state) => {
    state.currentDetails = { ...initialState.currentDetails };
    return state;
  },
  [ACTIVATE_OR_DEACTIVATE_SCHEMA]: (state) => {
    state.activateOrDeactivateSucceeded = false;
    state.activateOrDeactivateFailed = false;
    state.activateOrDeactivateFailedMessage = '';
    return state;
  },
  [ACTIVATE_OR_DEACTIVATE_SCHEMA_SUCCEEDED]: (state, action) => {
    state.activateOrDeactivateSucceeded = action.payload;
    return state;
  },
  [ACTIVATE_OR_DEACTIVATE_SCHEMA_FAILED]: (state, action) => {
    state.activateOrDeactivateFailedMessage = action.payload.activeStatus
      ? 'Unable to archive schema. Please check and try again.'
      : 'Unable to activate schema. Please check and try again.';
    state.activateOrDeactivateFailed = true;
  },
  [LOADING_CURRENT_SCHEMA]: (state) => {
    state.schemaSaveFailed = false;
    return state;
  },
  [GET_EVENT_IDENTIFIER_VALUES]: (state) => {
    state.eventIdentifier = {
      isLoading: true,
      values: []
    };
    return state;
  },
  [GETTING_EVENT_IDENTIFIER_VALUES_SUCCEEDED]: (state, action) => {
    state.eventIdentifier = {
      isLoading: false,
      values: action.payload
    };
    return state;
  },
  [GETTING_SCHEMA_OPTIONS_SUCCEEDED]: (state, action) => {
    state.schemaOptions = {
      ...state.schemaOptions,
      [action.payload.fieldType]: action.payload.options
    };
    return state;
  },
  [GETTING_SCHEMA_OPTIONS_FAILED]: (state, action) => {
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [UPDATE_SCHEMA_FILTERS]: (state, action) => {
    state.gettingPaginated = true;
    state.filters = {
      ...state.filters,
      ...action.payload
    };
    return state;
  },
  [RESET_SCHEMA_FILTERS]: (state) => {
    state.gettingPaginated = true;
    state.filters = { ...initialState.filters };
    return state;
  }
});
